export function adminData(
  state = {
    dashboardData: [],
    users: [],
    currentUser: [],
    currentCompany: [],
  },
  action
) {
  let users = [];
  switch (action.type) {
    case 'GET_DASHBOARD_DATA_START':
      return {
        ...state,
        dashboardData: [],
        users: [],
        currentUser: [],
        currentCompany: [],
      };
    case 'GET_DASHBOARD_DATA_DONE':
      return {
        ...state,
        dashboardData: action.dashboardData,
      };
    case 'GET_All_ADMIN_USERS_DATA_START':
      return {
        ...state,
        dashboardData: [],
        users: [],
        currentUser: [],
        currentCompany: [],
      };

    case 'GET_All_ADMIN_USERS_DATA_DONE':
      return {
        ...state,
        users: action.users,
      };
    case 'GET_SINGLE_ADMIN_USER_DATA_START':
      return {
        ...state,
        currentUser: [],
      };

    case 'GET_SINGLE_ADMIN_USER_DATA_DONE':
      return {
        ...state,
        currentUser: action.currentUser,
      };
    case 'GET_SINGLE_ADMIN_COMPANY_DATA_START':
      return {
        ...state,
        currentCompany: [],
      };

    case 'GET_SINGLE_ADMIN_COMPANY_DATA_DONE':
      return {
        ...state,
        currentCompany: action.currentCompany,
      };
    case 'DEACTIVATE_USER_BY_ID_START':
      return {
        ...state,
      };

    case 'DEACTIVATE_USER_BY_ID_DONE':
      users = state.users.map(user => {
        if (user.userId === action.userId) {
          user.state = user.state === 'Deactivated' ? 'Active' : 'Deactivated';
        }
        return user;
      });
      return {
        ...state,
        users,
      };
    case 'DEACTIVATE_USER_PERMA_BY_ID_DONE':
      users = state.users.map(user => {
        if (user.userId === action.userId) {
          user.state = 'Deactivated_permanently';
        }
        return user;
      });
      return {
        ...state,
        users,
      };

    case 'APPROVE_USER_BY_ID_START':
      return {
        ...state,
      };

    case 'APPROVE_USER_BY_ID_DONE':
      users = state.users.map(user => {
        if (user.userId === action.userId) {
          user.state =
            user.state === 'Pending_approval' ? 'Active' : 'Pending_approval';
        }
        return user;
      });
      return {
        ...state,
        users,
      };

    case 'DISAPPROVE_USER_BY_ID_START':
      return {
        ...state,
      };

    case 'DISAPPROVE_USER_BY_ID_DONE':
      users = state.users.map(user => {
        if (user.userId === action.userId) {
          user.state =
            user.state === 'Pending_approval' ? 'Declined' : 'Pending_approval';
        }
        return user;
      });
      return {
        ...state,
        users,
      };

    default:
      return state;
  }
}
